import { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from "react-bootstrap/Modal";
import { Col, Container, Row } from "react-bootstrap";
import { TermsAndConditionsContentInvestCEO } from "../../docs/terms/investceo/latest";
import { TermsAndConditionsContentALM } from "../../docs/terms/alm/latest";
import { determineTenant } from "../../utils/tenants";
import { PrivacyPolicyContentALM } from "../../docs/privacy/alm/latest";


export const TermsAndConditionsModal = ({
    showModal,
    handleTermsSubmit,
}) => {

    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [isRiskChecked, setIsRiskChecked] = useState(false);

    const handleIsTermsChecked = (e) => {
        setIsTermsChecked(e.target.checked);
    }

    const handleIsRiskChecked = (e) => {
        setIsRiskChecked(e.target.checked);
    }

    return (
        <Modal
            size="xl"
            show={showModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <h2 className="mt-3 mb-3 pb-3 border-bottom">
                    Terms & Conditions
                </h2>
                <Container style={{ height: '300px', overflowY: 'scroll', border: '1px solid #ccc', backgroundColor: 'rgb(128 128 128 / 10%)' }}>
                    {
                        determineTenant() === 'investceo' &&
                        <TermsAndConditionsContentInvestCEO />
                    }
                    {
                        determineTenant() === 'alm' &&
                        <TermsAndConditionsContentALM />
                    }
                </Container>
                <h2 className="mt-3 mb-3 pb-3 pt-3 border-bottom">
                    Privacy Policy
                </h2>
                <Container style={{ height: '300px', overflowY: 'scroll', border: '1px solid #ccc', backgroundColor: 'rgb(128 128 128 / 10%)' }}>
                    <PrivacyPolicyContentALM />
                </Container>
                <Row className="mt-5 mb-3">
                    <Col>
                        <Form.Check
                        className="mb-2"
                            style={{
                                border: "2px solid red", /* darker outline */
                                borderColor: "red",
                                cursor: "pointer",
                                padding: "1rem 2rem",
                            }}
                            type="checkbox"
                            id="isTermsChecked"
                            name="isTermsChecked"
                            label="By checking this box, I acknowledge that I have read, understood, and agree to be bound by the Terms & Conditions and the Privacy Policy above."
                            checked={isTermsChecked}
                            onChange={(e) => handleIsTermsChecked(e)}
                            value={isTermsChecked}
                        />
                        <Form.Check
                            style={{
                                border: "2px solid red", /* darker outline */
                                borderColor: "red",
                                cursor: "pointer",
                                padding: "1rem 2rem",
                            }}
                            type="checkbox"
                            id="riskCheckbox"
                            name="riskCheckbox"
                            label="I understand that trading involves significant risk of loss, that past performance is not indicative of future results, and that ALM Trading and your Licensor do not provide investment advice."
                            checked={isRiskChecked}
                            onChange={(e) => handleIsRiskChecked(e)}
                            value={isRiskChecked}
                        />
                    </Col>
                </Row>
                <div className="mt-3 d-flex justify-content-center">
                    <Button
                        variant="primary"
                        disabled={!isTermsChecked || !isRiskChecked}
                        onClick={() => handleTermsSubmit()}>
                        Save
                    </Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}